import momenJalaali from "moment-jalali";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, Popover, Row } from "react-bootstrap";
import { DashCircle, DashCircleFill, EyeFill, EyeSlashFill, FileEarmarkExcelFill, Printer, Search } from "react-bootstrap-icons";
import { getUserList, getDashboartReport, rejectReferByThirdParty, rejectReferByThirdPartyAsync } from "../store/api/FlowAPI";
import { useEffect, useReducer, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import BihamtaTable from "../../Components/BihamtaTable";
import Loader from 'react-loader-spinner';
import { faEject, faEnvelopeOpen } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker2";
import { exportToExcel, invoiceTypesArray, setErrorDialog } from "../../store/api/CommonFunctions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function UserDashboardReport() {
    const history = useHistory();
    const rejectRef = useRef({});
    const [userList, setUserList] = useState();
    const { handleSubmit, register } = useForm();
    const frmFilters = useRef();
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);
    const [pendingReject, setPendingReject] = useState(false);
    const [showFilter, setShowFilter] = useState(true);

    const [dateFilters, setDateFilters] = useState({});
    const filterData = useSelector(state =>
        state.FlowData.dashboardReportFilters);
    const popReject = (
        <Popover style={{ fontSize: "12px", width: "350px" }}>
            <Popover.Title className="headerStyle">
                <FontAwesomeIcon icon={faEject} size="lg" />&nbsp;
                رد مدیریتی ارجاع
            </Popover.Title>
            <Popover.Content className="bodyStyle">
                <label style={{ position: "relative" }}>
                    شرح رد<span style={{ color: "red", position: "absolute", top: -3, right: -5 }}>*</span>:
                </label>
                <Form.Group>
                    <Form.Control onChange={e => rejectRef.current.Desc = e.target.value} onKeyDown={handleRejectDescKeyDown} />
                </Form.Group>
                <Button variant="info" className="w-100 mt-1" onClick={reject} disabled={pendingReject}>رد ارجاع</Button>
            </Popover.Content>
        </Popover>
    )
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف" },
        { colName: "PDocumentType", colTitle: "نوع فرم", showInMobile: true },
        { colName: "PDocumentDate", colTitle: "تاریخ فرم", showInMobile: true },
        { colName: "DocumentNumber", colTitle: "شماره فرم", showInMobile: true },
        { colName: "PEnterDate", colTitle: "تاریخ ارجاع" },
        { colName: "PExitDate", colTitle: "تاریخ انجام" },
        { colName: "ReferBy", colTitle: "ارجاع دهنده" },
        { colName: "ReferTo", colTitle: "ارجاع به" },
        { colName: "ReferDescription", colTitle: "شرح ارجاع" },
        { colName: "DocumentStatus", colTitle: "وضعیت ورودی" },
        { colName: "ExitDocumentStatus", colTitle: "وضعیت خروجی" },
        { colName: "LastStatus", colTitle: "وضعیت کنونی" },
        { colName: "PDeadlineDate", colTitle: "تاریخ سررسید", styleCondition: (row) => row.DeadlineColor ? { backgroundColor: row.DeadlineColor } : { backgroundColor: "unset" } },
        { colName: "PWorkDeadline", colTitle: "مهلت انجام کل کار", styleCondition: (row) => row.WorkDeadlineColor ? { backgroundColor: row.WorkDeadlineColor } : { backgroundColor: "unset" } }
    ]
    const tableButtons = [
        {
            type: "overlay", overlay: popReject,
            icon: <DashCircleFill color="orangered" size={16} className="rowBtn"/>,
            tooltip: "رد مدیریتی ارجاع",
            title: "رد مدیریتی ارجاع",
            onclick: row => rejectRef.current.ID = row.ID,
            showCondition: row => !(row.PExitDate?.length > 0)
        }
    ]
    function search(data) {
        const mdFrom = document.getElementsByName("EnterDateFrom")[0].value;
        if (mdFrom !== "") {
            data.EnterDateFrom = dateFilters.EnterDateFrom;
            data.PEnterDateFrom = mdFrom;
        }
        else {
            dateFilters.EnterDateFrom = null;
            data.PEnterDateFrom = null;
        }
        const mdTo = document.getElementsByName("EnterDateTo")[0].value;
        if (mdTo !== "") {
            data.EnterDateTo = dateFilters.EnterDateTo;
            data.PEnterDateTo = mdTo;
        }
        else {
            dateFilters.EnterDateTo = null;
            data.PEnterDateTo = null;
        }
        const rdFrom = document.getElementsByName("ExitDateFrom")[0].value;
        if (rdFrom !== "") {
            data.ExitDateFrom = dateFilters.ExitDateFrom;
            data.PExitDateFrom = rdFrom;
        }
        else {
            dateFilters.ExitDateFrom = null;
            data.PExitDateFrom = null;
        }
        const rdTo = document.getElementsByName("ExitDateTo")[0].value;
        if (rdTo !== "") {
            data.ExitDateTo = dateFilters.ExitDateTo;
            data.PExitDateTo = rdTo;
        }
        else {
            dateFilters.ExitDateTo = null;
            data.PExitDateTo = null;
        }
        data.Skip = 0;
        data.Take = 10;
        dispatch(getDashboartReport(data));
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function toExcel() {
        const url = "api/UserDashboardAPI/GetDashboartReport";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("UserDashboardReport", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = 0;
        history.push({
            pathname: `/PrintViewer/UserDashboardReport/${e.ctrlKey}`,
            state: {
                dataUrl: `api/UserDashboardAPI/GetDashboartReport`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function rowClick(row) {
        // const base = window.location.origin;

        const attachType = row.DocumentType?.replaceAll("Formal", "").toLowerCase();
        if (invoiceTypesArray.some(i => i.TypeName.toLowerCase() === attachType)) {
            window.open(`/Sale/Invoice/${attachType}/${row.DocumentID}/${row.DocumentType.includes("Formal")}`);
        }
        else if (attachType.toLowerCase() === "install" || attachType === "repair") {
            window.open(`/Services/Service/${row.DocumentID}/${row.DocumentType}`)
        }
        // else if(attachType.contains("cheque"))
        // {
        //     setModalCheqFunctions({
        //         Show: true,
        //         FunctionID: row.OperationID,
        //         ChequeStatus: row.OperationType/*,
        //         ChequeID: row.ChequeID*/
        //     })
        // }
        else if (attachType === "customer") {
            window.open(`/CRM/AddEditCustomer/${row.OperationID}`);
        }
        else if (attachType === "precustomer" || attachType === "pre_customer") {
            window.open(`/CRM/AddEditPreCustomer/${row.OperationID}`);
        }

    }
    async function reject() {
        if (pendingReject) {
            return;
        }

        if (!(rejectRef.current.Desc?.length > 0 || !rejectRef.current.ID)) {
            return;
        }
        setPendingReject(true);
        const result = await rejectReferByThirdPartyAsync(rejectRef.current.ID, rejectRef.current.Desc);
        setPendingReject(false);
        if (result.Message) {
            setErrorDialog(dispatch, result.Message);
        }
        else if (result.Data) {
            rejectRef.current = {};
            setErrorDialog(dispatch, "success", 3000);
            search(filterData);
        }
    }
    function handleRejectDescKeyDown(e) {
        if (e.key !== "Enter") {
            return;
        }
        e.preventDefault();
        reject();
    }
    useEffect(() => {
        document.body.classList = "notMain";
        getUserList("", setUserList);
    }, [])
    return (
        <div className="container-fluid mt-1">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faEnvelopeOpen} size="lg" />&nbsp;
                    گزارش گردش کارهای کارتابل
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form readOnly onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                            </div>
                            <Col md={1} className="form-group">
                                <label className="ellipsisLabel">ارجاع از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="EnterDateFrom"
                                    value={dateFilters.EnterDateFrom ? momenJalaali(dateFilters.EnterDateFrom) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, EnterDateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={1} className="form-group">
                                <label className="ellipsisLabel">ارجاع تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="EnterDateTo"
                                    value={dateFilters.EnterDateTo ? momenJalaali(dateFilters.EnterDateTo) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, EnterDateTo: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={1} className="form-group">
                                <label className="ellipsisLabel">انجام از:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="ExitDateFrom"
                                    value={dateFilters.ExitDateFrom ? momenJalaali(dateFilters.ExitDateFrom) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, ExitDateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={1} className="form-group">
                                <label className="ellipsisLabel">انجام تا:</label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="ExitDateTo"
                                    value={dateFilters.ExitDateTo ? momenJalaali(dateFilters.ExitDateTo) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, ExitDateTo: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نوع فرم:</label>
                                <select className="search-input" name="DocumentType" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="install">سرویس نصب</option>
                                    <option value="repair">سرویس تعمیر</option>
                                    <option value="invoice">فاکتورها</option>
                                    <option value="customer">مشتریان</option>
                                    <option value="pre_customer">مشتریان بالقوه</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره فرم:</label>
                                <input className="search-input" name="DocumentNumber" ref={register({})} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>وضعیت انجام:</label>
                                <select className="search-input" name="Exited" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>انجام نشده</option>
                                    <option value={true}>انجام شده</option>
                                </select>
                            </Col>
                            <Col md={2} className='form-group'>
                                <label>ارجاع دهنده:</label>
                                {userList === "PENDING" &&
                                    <div className='search-input col-md-3'>
                                        <Loader type="BallTriangle" color="#bb1370" height={18} width={18} style={{ display: "inline-block" }} />
                                        <span style={{ color: "#817d7f" }}>&nbsp;در حال بارگذاری فهرست</span>
                                    </div>
                                }
                                {Array.isArray(userList) &&
                                    <select className="search-input" name="ReferredBy" ref={register({})}>
                                        <option value="">انتخاب کنید</option>
                                        {userList.map((item, i) => { return (<option key={i} value={item.ID}>{item.Name}</option>) })}
                                    </select>
                                }
                            </Col>
                            <Col md={2} className='form-group'>
                                <label>ارجاع به</label>
                                {userList === "PENDING" &&
                                    <div className='search-input col-md-3'>
                                        <Loader type="BallTriangle" color="#bb1370" height={18} width={18} style={{ display: "inline-block" }} />
                                        <span style={{ color: "#817d7f" }}>&nbsp;در حال بارگذاری فهرست</span>
                                    </div>
                                }
                                {Array.isArray(userList) &&

                                    <select className="search-input" name="ReferredTo" ref={register({})}>
                                        <option value="">انتخاب کنید</option>
                                        {userList.map((item, i) => { return (<option key={i} value={item.ID}>{item.Name}</option>) })}
                                    </select>
                                }
                            </Col>
                            {/* <Col md={2} className="form-group">
                                <label>تعداد در صفحه:</label>
                                <select className="search-input" name="Take" ref={register({})} defaultValue={10}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </Col> */}
                            <Col md={2} className="form-group">
                                <label className="ellipsisLabel">به ترتیب:</label>
                                <select className="search-input" name="OrderBy" ref={register({})} defaultValue="ENTER">
                                    <option value="ENTER">تاریخ ارجاع</option>
                                    <option value="ENTER DESC">تاریخ ارجاع-نزولی</option>
                                    <option value="EXIT">تاریخ انجام</option>
                                    <option value="EXIT DESC">تاریخ انجام-نزولی</option>
                                </select>
                            </Col>
                        </Row>
                        <Button type="submit" className="group-Btn-large mb-1 mt-1"><Search size={18} />&nbsp; جستجوی کارها</Button>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <Printer onClick={printReport} size={25} style={{ cursor: "pointer" }} className="hoverIcon" color='blue' />
                        </div>}
                    <BihamtaTable
                        reducerName="FlowData"
                        objectName="dashboartReport"
                        columns={tableCols}
                        filterData={filterData}
                        pageSizeList={[10, 20, 50, 100, 200, 500, 900]}
                        defaultPageSize={10}
                        searchMethod={(data) => dispatch(getDashboartReport(data))}
                        rowButtons={tableButtons}
                        rowClick={rowClick} maxHeight={500} hasPaging={true} className="mb-0 mt-0" searchable />
                </Card.Body>
            </Card>
        </div>
    )
}